export const searchTreeCss = ({ className, overrideCss, isCollapsed, } = {}) => {
    const searchTree = [];
    const searchTreeHeader = [];
    const searchTreeList = [];
    const searchTreeItem = [];
    const searchTreeCollapseButton = [];
    if (!overrideCss) {
        searchTree.push('search-tree');
        searchTreeHeader.push('search-tree__header');
        searchTreeList.push('search-tree__list');
        searchTreeItem.push('search-tree__item');
        searchTreeCollapseButton.push('search-tree__collapse-button');
    }
    if (className) {
        searchTree.push(`${className}`);
        searchTreeHeader.push(`${className}__header`);
        searchTreeList.push(`${className}__list`);
        searchTreeItem.push(`${className}__item`);
        searchTreeCollapseButton.push(`${className}__collapse-button`);
    }
    if (isCollapsed) {
        if (!overrideCss) {
            searchTree.push('search-tree--collapsed');
            searchTreeCollapseButton.push('search-tree__collapse-button--collapsed');
            searchTreeHeader.push('search-tree__header--collapsed');
        }
        if (className) {
            searchTree.push(`${className}--collapsed`);
            searchTreeCollapseButton.push(`${className}__collapse-button--collapsed`);
            searchTreeHeader.push(`${className}__header--collapsed`);
        }
    }
    return {
        searchTree: searchTree.join(' '),
        searchTreeHeader: searchTreeHeader.join(' '),
        searchTreeList: searchTreeList.join(' '),
        searchTreeItem: searchTreeItem.join(' '),
        searchTreeCollapseButton: searchTreeCollapseButton.join(' '),
    };
};
//# sourceMappingURL=searchTreeCss.js.map